<template>
  <div class="realname-dialog">
    <div class="title">实名认证</div>
    <div class="steps">
      <el-steps :active="currentStep" align-center>
        <el-step title="个人资料" icon="el-icon-user-solid"></el-step>
        <el-step title="毕业院校" icon="el-icon-s-opportunity"></el-step>
        <el-step title="工作经历" icon="el-icon-s-cooperation"></el-step>
      </el-steps>
    </div>
    <div v-if="currentStep === 0" class="personal-info">
      <div class="row">
        <div class="left input-row"><span class="red">*</span>考试类型</div>
        <div class="right">
          <el-radio-group v-model="examType">
            <el-radio :label="0">初次培训</el-radio>
            <el-radio :label="1">换证培训</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="left input-row"><span class="red">*</span>真实姓名</div>
        <div class="right">
          <el-input
            v-model="realname"
            placeholder="请输入您的真实姓名"
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="left input-row"><span class="red">*</span>身份证号</div>
        <div class="right">
          <el-input
            v-model="idno"
            placeholder="请输入您的身份证号"
            maxlength="18"
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="left"><span class="red">*</span>个人2寸照片</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 3 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingPersonalPicUrl"
          >
            <img
              v-if="personalPicUrl.length > 0"
              :src="personalPicUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/personal_pic_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div class="row">
        <div class="left"><span class="red">*</span>身份证人面照</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 0 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingIdImgUrl"
          >
            <img
              v-if="idImgUrl.length > 0"
              :src="idImgUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/id_img_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div v-if="examType === 0" class="row">
        <div class="left"><span class="red">*</span>护士执业证书</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 1 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingNurseCertUrl"
          >
            <img
              v-if="nurseCertUrl.length > 0"
              :src="nurseCertUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/nurse_cert_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div v-if="examType === 1" class="row">
        <div class="left"><span class="red">*</span>往期结业证书</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 2 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingPreCertImgUrl"
          >
            <img
              v-if="preCertImgUrl.length > 0"
              :src="preCertImgUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/pre_cert_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div v-if="examType === 1" class="row">
        <div class="left input-row"><span class="red">*</span>证书编号</div>
        <div class="right">
          <el-input
            v-model="preCertNo"
            placeholder="请输入您的证书编号"
          ></el-input>
        </div>
      </div>
      <div class="next-btn" @click="savePersonalInfo" v-loading="submitting">
        下一步
      </div>
    </div>
    <div v-if="currentStep === 1" class="education-info">
      <div class="row">
        <div class="left input-row"><span class="red">*</span>学历</div>
        <div class="right">
          <el-select v-model="eduLevel" placeholder="请选择学历">
            <el-option
              v-for="edu in eduList"
              :key="edu.level"
              :label="edu.name"
              :value="edu.level"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="examType === 0" class="row">
        <div class="left"><span class="red">*</span>毕业证</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 4 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingEduPicUrl"
          >
            <img
              v-if="eduPicUrl.length > 0"
              :src="eduPicUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/education_img_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div class="next-btn" @click="saveEduInfo" v-loading="submitting">
        下一步
      </div>
    </div>
    <div v-if="currentStep === 2" class="work-info">
      <div class="row">
        <div class="left input-row"><span class="red">*</span>医院名称</div>
        <div class="right">
          <el-select
            v-model="hospital"
            filterable
            remote
            reserve-keyword
            placeholder="请输入您所在医院名称"
            :remote-method="loadHospital"
            :loading="loadingHospital"
          >
            <el-option
              v-for="hos in hospitalList"
              :key="hos.hospital"
              :label="hos.hospital"
              :value="hos.hospital"
            >
            </el-option>
          </el-select>
          <div class="hospital-tips" @click="showHospitalTips">
            找不到您所在医院？
          </div>
        </div>
      </div>
      <div class="row">
        <div class="left input-row"><span class="red">*</span>医院等级</div>
        <div class="right">
          <el-input
            v-model="hosLevel"
            placeholder="请输入您所在医院的等级"
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="left input-row"><span class="red">*</span>办公室电话</div>
        <div class="right">
          <el-input
            v-model="officeTel"
            placeholder="请输入您所在办公室电话"
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="left input-row"><span class="red">*</span>职称</div>
        <div class="right">
          <el-input v-model="techTitle" placeholder="请输入您的职称"></el-input>
        </div>
      </div>
      <div v-if="examType === 0" class="row">
        <div class="left"><span class="red">*</span>医疗机构执业许可证副本</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 5 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingHosCertImgUrl"
          >
            <img
              v-if="hosCertImgUrl.length > 0"
              :src="hosCertImgUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/hos_cert_img_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div v-if="examType === 0" class="row">
        <div class="left">
          <span class="red">*</span>山东省专科护士岗位培训申请表
        </div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 6 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingApplyUrl"
          >
            <img
              v-if="applyUrl.length > 0"
              :src="applyUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/apply_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div v-if="examType === 0" class="row">
        <div class="left"><span class="red">*</span>实习意向表</div>
        <div class="right img-mode">
          <el-upload
            class="pic-uploader"
            action="/file/importPicture"
            :http-request="uploadPic"
            :data="{ mode: 7 }"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :on-error="handlePicUploadError"
            :v-loading="uploadingServuyUrl"
          >
            <img
              v-if="internServuyImgUrl.length > 0"
              :src="internServuyImgUrl"
              class="preview-pic"
            />
            <img
              v-else
              class="pic-uploader-bg"
              src="../../assets/realname/servuy_bg.png"
            />
          </el-upload>
        </div>
      </div>
      <div class="next-btn" @click="saveWorkInfo" v-loading="submitting">
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      currentStep: 0,
      submitting: false,
      realname: "",
      idno: "",
      personalPicUrl: "", // 个人2寸照片
      uploadingPersonalPicUrl: false, // 个人2寸照片
      idImgUrl: "", // 身份证照片
      uploadingIdImgUrl: false, // 身份证照片
      nurseCertUrl: "", // 护士执业证书
      uploadingNurseCertUrl: false, // 护士执业证书
      preCertImgUrl: "", // 往期结业证书
      uploadingPreCertImgUrl: false, // 往期结业证书
      preCertNo: "", // 往期结业证书编号
      eduLevel: "", // 学历 0:中专 1：大专 2：本科 3：研究生 4：博士 5：其他
      eduList: [
        { level: 0, name: "中专" },
        { level: 1, name: "大专" },
        { level: 2, name: "本科" },
        { level: 3, name: "研究生" },
        { level: 4, name: "博士" },
        { level: 5, name: "其它" }
      ],
      eduPicUrl: "", // 毕业证照片
      uploadingEduPicUrl: false, // 毕业证照片
      hospital: "", // 选中的医院
      hospitalList: [], // 医院列表
      loadingHospital: false, // 加载医院列表的标志
      hosLevel: "", // 医院等级
      officeTel: "", // 办公室电话
      techTitle: "", // 职称
      hosCertImgUrl: "", // 医院执业资格证
      uploadingHosCertImgUrl: false, // 医院执业资格证
      applyUrl: "", // 申请表
      uploadingApplyUrl: false, // 申请表
      examType: 0, // 0：初次考试 1：换证考试
      internServuyImgUrl: "", // 实习意向表
      uploadingServuyUrl: false
    };
  },
  created: function() {
    // 根据当前用户的状态，判断显示到第几步
    const user = JSON.parse(localStorage.getItem("pc_user"));
    if (user !== null && user !== undefined) {
      if (user.authStatus === 2) {
        this.$message.success("您已通过实名认证");
        this.$router.push({ path: "/" });
        return;
      }
      if (user.infoIntegrity === 3 && user.authStatus === 0) {
        this.$message.error("您的实名认证已提交，等待审核");
        this.$router.push({ path: "/" });
        return;
      }
      this.currentStep = user.authStatus === 3 ? 0 : user.infoIntegrity;
      this.examType =
        user.certificateNumber === null ||
        user.certificateNumber === undefined ||
        user.certificateNumber.length === 0
          ? 0
          : 1;
    } else {
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    showHospitalTips() {
      this.$alert(
        "如列表中无您的医院名称或医院名称有错误，请联系工作人员增改，联系电话：0531-88955796",
        "提示",
        {
          confirmButtonText: "确定"
        }
      );
    },
    async loadHospital(hosKeyword) {
      if (hosKeyword !== "") {
        this.loadingHospital = true;
        const params = { queryParam: hosKeyword };
        const res = await httpRequest("/app/hospital/hospitals", "get", params);
        if (res !== null && res !== undefined && res.code === 200) {
          this.hospitalList = res.data;
        }
        this.loadingHospital = false;
      } else {
        this.hospitalList = [];
      }
    },
    async saveWorkInfo() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.hospital.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您所在医院！");
        return;
      }
      if (this.hosLevel.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您所在医院等级！");
        return;
      }
      if (this.officeTel.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您所在办公室电话！");
        return;
      }
      if (this.techTitle.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您的职称！");
        return;
      }
      if (this.examType === 0 && this.hosCertImgUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您所在医院执业许可证副本照片！");
        return;
      }
      if (this.examType === 0 && this.applyUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的护士岗位培训申请表照片！");
        return;
      }
      if (this.examType === 0 && this.internServuyImgUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的实习意向表照片！");
        return;
      }
      this.submitting = true;
      const params = {
        hospital: this.hospital,
        position: this.techTitle,
        hospitalLevel: this.hosLevel,
        officePhone: this.officeTel,
        licenseUrl: this.examType === 0 ? this.hosCertImgUrl : "",
        applicationUrl: this.examType === 0 ? this.applyUrl : "",
        practiceSurveyUrl: this.examType === 0 ? this.internServuyImgUrl : ""
      };
      const res = await httpRequest("/app/user/we", "post", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.submitting = false;
        this.$message.success("您的申请已提交，等待审核！");
        localStorage.setItem("pc_user", JSON.stringify(res.data));
        this.$router.push({ path: "/" });
      }
    },
    async saveEduInfo() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.eduLevel.length === 0) {
        this.submitting = false;
        this.$message.error("请选择您的学历！");
        return;
      }
      if (this.examType === 0 && this.eduPicUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的毕业证书！");
        return;
      }
      this.submitting = true;
      const params = {
        edtBg: this.eduLevel,
        graduationUrl: this.examType === 0 ? this.eduPicUrl : ""
      };
      const res = await httpRequest("/app/user/eb", "post", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.submitting = false;
        this.$message.success("学历信息保存成功！");
        localStorage.setItem("pc_user", JSON.stringify(res.data));
        this.currentStep++;
      }
    },
    async savePersonalInfo() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.realname.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您的真实姓名！");
        return;
      }
      if (this.idno.length !== 18) {
        this.submitting = false;
        this.$message.error("请输入18位的身份证号！");
        return;
      }
      if (this.personalPicUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的个人2寸照片！");
        return;
      }
      if (this.idImgUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的身份证照片！");
        return;
      }
      if (this.examType === 0 && this.nurseCertUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的护士执业证书照片！");
        return;
      }
      if (this.examType === 1 && this.preCertImgUrl.length === 0) {
        this.submitting = false;
        this.$message.error("请上传您的往期结业证书照片！");
        return;
      }
      if (this.examType === 1 && this.preCertNo.length === 0) {
        this.submitting = false;
        this.$message.error("请输入您的证书编号！");
        return;
      }

      this.submitting = true;
      const params = {
        realName: this.realname,
        identity: this.idno,
        pictureUrl: this.personalPicUrl,
        identityUrl: this.idImgUrl,
        vocatCertiUrl: this.examType === 0 ? this.nurseCertUrl : "",
        completeCourseUrl: this.examType === 0 ? "" : this.preCertImgUrl,
        certificateNumber: this.examType === 0 ? "" : this.preCertNo
      };
      const res = await httpRequest("/app/user/info", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.submitting = false;
        this.$message.success("个人资料保存成功！");
        localStorage.setItem("pc_user", JSON.stringify(res.data));
        this.currentStep++;
      }
    },
    handlePicUploadError() {
      this.$message.error("上传失败，请重试");
    },
    async uploadPic(params) {
      if (params.data.mode === 0) {
        this.uploadingIdImgUrl = true;
        this.idImgUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 1) {
        this.uploadingNurseCertUrl = true;
        this.nurseCertUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 2) {
        this.uploadingPreCertImgUrl = true;
        this.preCertImgUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 3) {
        this.uploadingPersonalPicUrl = true;
        this.personalPicUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 4) {
        this.uploadingEduPicUrl = true;
        this.eduPicUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 5) {
        this.uploadingHosCertImgUrl = true;
        this.hosCertImgUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 6) {
        this.uploadingApplyUrl = true;
        this.applyUrl = URL.createObjectURL(params.file);
      } else if (params.data.mode === 7) {
        this.uploadingServuyUrl = true;
        this.internServuyImgUrl = URL.createObjectURL(params.file);
      } else {
        return;
      }

      const formData = new FormData();
      formData.append(params.filename, params.file);
      let res = await httpRequest(params.action, "post", formData);
      if (res !== null && res !== undefined && res.code === 200) {
        this.$message.success("上传成功");
        if (params.data.mode === 0) {
          this.idImgUrl = res.data[0];
        } else if (params.data.mode === 1) {
          this.nurseCertUrl = res.data[0];
        } else if (params.data.mode === 2) {
          this.preCertImgUrl = res.data[0];
        } else if (params.data.mode === 3) {
          this.personalPicUrl = res.data[0];
        } else if (params.data.mode === 4) {
          this.eduPicUrl = res.data[0];
        } else if (params.data.mode === 5) {
          this.hosCertImgUrl = res.data[0];
        } else if (params.data.mode === 6) {
          this.applyUrl = res.data[0];
        } else if (params.data.mode === 7) {
          this.internServuyImgUrl = res.data[0];
        }
      } else {
        if (params.data.mode === 0) {
          this.uploadingIdImgUrl = false;
          this.idImgUrl = "";
        } else if (params.data.mode === 1) {
          this.uploadingNurseCertUrl = false;
          this.nurseCertUrl = "";
        } else if (params.data.mode === 2) {
          this.uploadingPreCertImgUrl = false;
          this.preCertImgUrl = "";
        } else if (params.data.mode === 3) {
          this.uploadingPersonalPicUrl = false;
          this.personalPicUrl = "";
        } else if (params.data.mode === 4) {
          this.uploadingEduPicUrl = false;
          this.eduPicUrl = "";
        } else if (params.data.mode === 5) {
          this.uploadingHosCertImgUrl = false;
          this.hosCertImgUrl = "";
        } else if (params.data.mode === 6) {
          this.uploadingApplyUrl = false;
          this.applyUrl = "";
        } else if (params.data.mode === 7) {
          this.uploadingServuyUrl = false;
          this.internServuyImgUrl = "";
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.realname-dialog {
  width: 100%;
  min-height: 1000px;
  background: #ffffff;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 40px;
  border-radius: 4px;
  color: rgba(51, 51, 51, 1);
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 176, 171, 1);
  }
  .steps {
    width: 800px;
    margin: 21px auto 50px auto;
  }
  .work-info {
    .hospital-tips {
      color: orange;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      cursor: pointer;
    }
  }
  .row {
    width: 500px;
    margin: 22px auto 0 auto;
    .left {
      display: inline-block;
      width: 100px;
      text-align: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(72, 72, 72, 1);
      vertical-align: top;
      .red {
        color: red;
      }
    }
    .input-row {
      height: 40px;
      line-height: 40px;
    }
    .right {
      display: inline-block;
      width: 370px;
      margin-left: 30px;
      height: 40px;
      line-height: 40px;
      text-align: left;
      .el-input {
        width: 370px;
      }
      .el-select {
        width: 370px;
      }
      .pic-uploader {
        cursor: pointer;
        .preview-pic,
        .pic-uploader-bg {
          width: 370px;
          height: 240px;
          object-fit: contain;
          border-radius: 4px;
        }
        .preview-pic {
          width: 368px !important;
          height: 238px !important;
          border: 1px solid lightgray;
        }
      }
      .tips {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(172, 172, 172, 1);
        text-align: left;
      }
    }
    .img-mode {
      height: 200px !important;
    }
  }
  .next-btn {
    width: 500px;
    height: 44px;
    line-height: 44px;
    background: rgba(0, 176, 171, 1);
    border-radius: 4px;
    margin: 40px auto 0 auto;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
